import { useEffect, useState } from 'react'
import { Modal, Checkbox, Button, Space } from 'antd'
import {
  DEFAULT_VISIBLE_COLUMN_KEYS,
  LIST_COLUMN_DEFS,
} from './listColumns'

type Props = {
  open: boolean
  initialKeys: string[]
  onCancel: () => void
  onConfirm: (columns: string[]) => void
}

export default function ColumnSettingsModal({ open, initialKeys, onCancel, onConfirm }: Props) {
  const [checked, setChecked] = useState<string[]>(initialKeys)

  useEffect(() => {
    if (open) setChecked(initialKeys.length ? initialKeys : DEFAULT_VISIBLE_COLUMN_KEYS)
  }, [open, initialKeys])

  const allChecked = checked.length === LIST_COLUMN_DEFS.length
  const indeterminate = checked.length > 0 && !allChecked

  return (
    <Modal
      title="自定义列表列"
      open={open}
      onCancel={onCancel}
      width={560}
      footer={
        <Space>
          <Button onClick={onCancel}>取消</Button>
          <Button
            type="primary"
            disabled={!checked.length}
            onClick={() => onConfirm(checked)}
          >
            确认
          </Button>
        </Space>
      }
    >
      <div className="mb-3 text-gray-500 text-sm">
        勾选要在表格中显示的列；可在列表表头拖拽调整列顺序。「操作」列始终显示且固定在最右侧。
      </div>
      <div className="mb-3">
        <Checkbox
          indeterminate={indeterminate}
          checked={allChecked}
          onChange={(e) =>
            setChecked(e.target.checked ? DEFAULT_VISIBLE_COLUMN_KEYS : [])
          }
        >
          全选
        </Checkbox>
      </div>
      <Checkbox.Group
        className="w-full"
        value={checked}
        onChange={(vals) => setChecked(vals as string[])}
      >
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {LIST_COLUMN_DEFS.map((c) => (
            <Checkbox key={c.key} value={c.key}>
              {c.label}
            </Checkbox>
          ))}
        </div>
      </Checkbox.Group>
    </Modal>
  )
}
